import React from "react";
import ChangeArrow from "./ChangeArrow";
import I18N from "../I18N";
import { T } from "../traks";
import { Row } from "reactstrap";

export const PortfolioInfoBox = ({
	title,
	items = [],
	infoText,
}) => {
	return (
		<div className="ad_portfolio_infobox">
			<div className="ad_portfolio_infobox_header">
				{title}
			</div>
			<div className="ad_portfolio_infobox_body">
				{items.map((item, idx) => (
					<div className="ad_portfolio_infobox_row" key={idx}>
						<div className="ad_portfolio_infobox_label">
							{item.label}
						</div>
						<div className="ad_portfolio_infobox_value">
							{item.value}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export const PortfolioSummaryGrid = ({ summary, currencyFallback }) => {
const currencyTicker = summary && summary.totals && summary.totals.bankrollTicker ? summary.totals.bankrollTicker : currencyFallback;
const placeholder = <span>{I18N.floatval_unit(0, 2, currencyTicker)}</span>;

const shortingEnabled = summary && summary.settings && summary.settings.shortingEnabled === true;
const diversificationEnabled = summary && summary.settings && summary.settings.diversificationEnabled === true;
const betaEnabled = summary && summary.settings && summary.settings.betaEnabled === true;


 const totalChangeValue = summary
 	? (
 		<span className={`ad_portfolio_infobox_compound ${summary.totals.totalChangeAbsolute > 0 ? "ad_growth_positive" : (summary.totals.totalChangeAbsolute < 0 ? "ad_growth_negative" : "ad_growth_zero")}`}>
			{I18N.floatval_unit(summary.totals.totalChangeAbsolute, 2, currencyTicker)}
 			<span>
 				(<ChangeArrow pct={summary.totals.totalChangePercent} suffix="%" show_arrow={false} />)
 			</span>
 		</span>
 	) : placeholder;


	const bankAccountValue = summary ? 
	(
		<span className="ad_portfolio_infobox_compound ad_growth_positive">
			{I18N.floatval_unit(summary.totals.bankrollValue, 2, currencyTicker)}
		</span>
	) : placeholder;

	const overviewItems = summary ? [
	{
		label: <T>Bank Account</T>,
		value: bankAccountValue,
	},
	{
		label: <T>Invested Value</T>,
		value: I18N.floatval_unit(summary.totals.investedValue, 2, currencyTicker),
	},
	{
		label: <T>Total portfolio value</T>,
		value: I18N.floatval_unit(summary.totals.totalValue, 2, currencyTicker),
	},
 	{
 		label: <T>Portfolio return</T>,
 		value: totalChangeValue,
 	},
] : [
	{ label: <T>Bank Account</T>, value: placeholder },
	{ label: <T>Invested Value</T>, value: placeholder },
	{ label: <T>Total portfolio value</T>, value: placeholder },
	{ label: <T>Total Change</T>, value: placeholder },
];

if (shortingEnabled) {
	overviewItems.splice(2, 0, {
		label: <T>Shorted value</T>,
		value: summary.totals.shortProfit ? I18N.floatval_unit(summary.totals.shortProfit, 2, currencyTicker) : placeholder,
	})
}

const riskAdjustedValue = (summary && summary.totals && summary.totals.riskAdjustedReturnPercent) ? summary.totals.riskAdjustedReturnPercent : 0;
const betaScoreValue = (summary && summary.totals && summary.totals.betaScore) ? summary.totals.betaScore : 0;

let riskItems;
if (betaEnabled) {
	if (summary) {
        riskItems = [
            {
                label: <T>The risk-adjusted return of the portfolio</T>,
                value: (
                    <span className="ad_portfolio_infobox_compound">
                        <ChangeArrow pct={riskAdjustedValue} suffix="%" show_arrow={false} />
                    </span>
                ),
            },
            {
                label: <T>The risk score of the portfolio (Beta)</T>,
                value: (
                    <span>
                        <ChangeArrow pct={betaScoreValue} decimals={4} show_arrow={false} />
                    </span>
                )
            },
        ];
    } else {
        riskItems = [
            { label: <T>The risk-adjusted return of the portfolio</T>, value: (
                <span className="ad_portfolio_infobox_compound">
                    <ChangeArrow pct={0} suffix="%" show_arrow={false} />
                </span>
            ) },
            { label: <T>The risk score of the portfolio (Beta)</T>, value: (
                <span>
                    <ChangeArrow pct={0} decimals={4} show_arrow={false} />
                </span>
            ) },
        ];
    }
}


// TODO: Add diversification metrics when available
let diversificationItems = null;
if (diversificationEnabled && summary) {
	diversificationItems = [];
}

const placeHolderBox = <div className="ad_portfolio_infobox_placeholder"></div>

 return (
 	<Row className="ad_portfolio_summary_grid">
 		<PortfolioInfoBox title={<T>Overview</T>} items={overviewItems} />
		{ riskItems ? <PortfolioInfoBox title={<T>Risk</T>} items={riskItems} /> : placeHolderBox }
		{ diversificationItems ? <PortfolioInfoBox title={<T>Diversification</T>} items={diversificationItems} /> : placeHolderBox }
 	</Row>
 );
};



// WEBPACK FOOTER //
// ./src/c/PortfolioInfoBox.js